import { SwiperOptions } from "swiper";
// import "swiper/css";
import 'swiper/swiper-bundle.css'
import Swiper from "swiper";
import { Pagination, Navigation, Autoplay, FreeMode } from "swiper";

Swiper.use([Pagination, Navigation, Autoplay, FreeMode]);

export { SwiperOptions, Pagination, Navigation, Autoplay, FreeMode };
export default Swiper;



// WEBPACK FOOTER //
// ./src/utils/swiper.js